import { render } from "./FortigateView.vue?vue&type=template&id=6ca48e55"
import script from "./FortigateView.vue?vue&type=script&lang=js"
export * from "./FortigateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__